import { TextField } from '@material-ui/core'
import React, { useState } from 'react'
import injectStyles from 'react-jss'
import { useDispatch } from 'react-redux'
import { hideReduxModal } from '../../../Reducers/UI/actions'
import GenericFlatButton from '../../GenericFlatButton'

import { styles } from './styles'

const CommentModal = ({ requestData, addComment, classes }) => {
  const [comment, setComment] = useState(requestData.comment)
  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()

  const onSubmit = async () => {
    setIsLoading(true)

    await addComment(requestData, comment)
    dispatch(hideReduxModal())

    setIsLoading(false)
  }

  return (
    <div className={classes.modalContainer}>
      <div className={classes.modalTitle}>
        Do you want to leave any tips{' '}
        {requestData.isPTO ? '' : `to ${requestData.name}`} for BA?
      </div>
      <div className={classes.description}>
        This text will be displayed on the “
        {requestData.isPTO ? 'Time off screen' : 'Document individual screen'}“
        in BA app
      </div>
      <TextField
        value={comment}
        multiline={true}
        variant="outlined"
        minRows={10}
        maxRows={10}
        onChange={event => {
          const { value } = event.target
          if (value && value.length > 600) return
          setComment(value)
        }}
        classes={{
          input: classes.rejectReasonInput,
          root: classes.rejectReasonInputRoot,
        }}
      />
      <div className={classes.counter}>{`Symbols: ${
        comment ? comment.length : 0
      } from 600`}</div>
      <div className={classes.modalButtonContainer}>
        <GenericFlatButton
          type={'outline'}
          title={'Cancel'}
          onClick={() => {
            dispatch(hideReduxModal())
          }}
          disabled={isLoading}
        />
        <GenericFlatButton
          type={'filled'}
          title={'Add comment'}
          loading={isLoading}
          disabled={isLoading}
          onClick={onSubmit}
        />
      </div>
    </div>
  )
}

export default injectStyles(styles)(CommentModal)
